export const GET_HSNS = "GET_HSNS";
export const GET_HSN = "GET_HSN";
export const ADD_HSN = "ADD_HSN";
export const DELETE_HSN = "DELETE_HSN";
export const UPDATE_HSN = "UPDATE_HSN";
